import PropTypes from 'prop-types';

import { Box, Button } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import PenIcon from '../../../../res/svg/pen.svg';

const EditButton = ({ handleClick, text }) => {
  const { t } = useTransl();

  return (
    <Button
      onClick={handleClick}
      type="submit"
      variant="contained"
      color="primary"
      disableElevation
    >
      <Box display="flex" justifyContent="center" alignItems="center">
        <img
          src={PenIcon}
          alt={t('community.communityImg')}
          style={{ marginRight: '1rem' }}
        />
        {text}
      </Box>
    </Button>
  );
};

EditButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default EditButton;
